export default __webpack_public_path__ + "static/media/tool.a2612762.svg";